import * as mensagemAlertaActions from './mensagemAlertaActions';
export { default as mensagemAlertaReducer } from './mensagemAlertaReducer';
export { mensagemAlertaActions };
